import { Box, Button, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { useThemeColors } from '@/hooks/useThemeColors'

const MAX_LINES = 6

type Props = {
  text: string
  emptyLabel?: string
  fontSize?: string
}

export default function CollapsibleText({ text, emptyLabel = '—', fontSize = 'sm' }: Props) {
  const colors = useThemeColors()
  const [expanded, setExpanded] = useState(false)
  const trimmed = text?.trim() ?? ''
  const isLong = trimmed.split('\n').length > MAX_LINES || trimmed.length > 480

  if (!trimmed) {
    return (
      <Text fontSize={fontSize} color={colors.textMuted}>
        {emptyLabel}
      </Text>
    )
  }

  return (
    <Box>
      <Text
        fontSize={fontSize}
        color={colors.text}
        whiteSpace="pre-wrap"
        lineHeight="1.7"
        noOfLines={expanded || !isLong ? undefined : MAX_LINES}
      >
        {trimmed}
      </Text>
      {isLong ? (
        <Button
          variant="link"
          size="sm"
          colorScheme="blue"
          mt={1}
          px={0}
          height="auto"
          onClick={() => setExpanded((e) => !e)}
        >
          {expanded ? 'Show less' : 'Show more'}
        </Button>
      ) : null}
    </Box>
  )
}
